import fetch from '@/utils/fetch'
// 获取话题列表
export function getTopic(params) {
  return fetch({
    url: '/topic',
    method: 'get',
    params: {
      topic_object_number: params.topic_object_number,
      topic_object_type: params.topic_object_type,
      pagesize: params.pagesize,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 获取话题评论列表
export function getComment(params) {
  return fetch({
    url: '/topic/comment',
    method: 'get',
    params: {
      topic_number: params.topic_number,
      pagesize: params.pagesize,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 创建话题
export function createTopic(data) {
  return fetch({
    url: '/topic/create',
    method: 'post',
    data: data
  })
}
// 编辑话题
export function editTopic(data) {
  return fetch({
    url: '/topic/edit',
    method: 'post',
    data: data
  })
}
// 删除话题
export function deleteTopic(data) {
  return fetch({
    url: '/topic/delete',
    method: 'post',
    data: data
  })
}
// 创建评论
export function createComment(data) {
  return fetch({
    url: '/topic/comment/create',
    method: 'post',
    data: data
  })
}
// 删除评论
export function deleteComment(data) {
  return fetch({
    url: '/topic/comment/delete',
    method: 'post',
    data: data
  })
}
// 举报
export function createReport(data) {
  return fetch({
    url: '/topic/report/create',
    method: 'post',
    data: data
  })
}